module.exports = __webpack_public_path__ + "assets/img/tabs6.d60cfe32.png";